

import Vue from 'vue';
import FastClick from 'fastclick';
import router from './router';
import App from './App';
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


FastClick.attach(document.body);

Vue.use(AjaxPlugin);
Vue.use(LoadingPlugin);

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'development') {
Vue.http.defaults.baseURL = 'https://www-dev.oniontour.com/jp_travel_app/';
}

router.beforeEach((to, from, next) => {
document.title = to.meta.title;
next();
});

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js